module.exports = __webpack_public_path__ + "static/media/school_faculty_profession_mobile.5da796b4.svg";